<template>
  <div class="gf_live-theme-preset">
    <template v-if="!showEditPreset">
      <QuickNavigation
        :label="currentPreset.name"
        :is-edited-current-preset="isEditedCurrentPreset"
        @back="onBack"></QuickNavigation>
      <div class="gf_setting">
        <div class="setting">
          <template v-for="settingStyle in settingStyles" :key="settingStyle.key">
            <div class="gf_setting__preset">
              <p class="gf_setting__preset-title paragraph-11-medium">{{ settingStyle.title }}</p>
              <div class="gf_setting__list-item">
                <div
                  v-for="(item, index) in settingStyle.listPreset"
                  :key="index"
                  class="gf_setting__item"
                  :style="[stateStepOB === item.key ? { position: 'relative' } : {}]"
                  @click="settingStyleAction(item.key)">
                  <div class="gf_setting__item--icon">
                    <i :class="item.icon" />
                  </div>
                  <div class="gf_setting__item--label button-14-medium txt-hybrid-shade-light-100">
                    {{ item.name }}
                  </div>
                  <template
                    v-if="
                      ['color', 'text', 'button'].includes(item.key) && shopMeta.onboardingGlobalStyle.previewPreset
                    ">
                    <PopupStepOnboarding v-show="isFirstViewListPack(item)" :step="step" @next="nextStepOB" />
                  </template>
                  <div class="gf_setting__item--button">
                    <i class="icon icon-arrow-right" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="gf_setting_page_apply" :class="{ 'show-list': isShowListPageApplied }">
            <Teleport to="#tooltips">
              <Tooltip :pointer="true" :width="'auto'" />
            </Teleport>
            <p class="gf_setting_page_apply-count">
              Applied to {{ lengthListPageApplied }} Page{{ lengthListPageApplied > 1 ? 's' : '' }}
            </p>
            <div
              v-if="lengthListPageApplied > 0"
              ref="pageApplyAction"
              class="gf_setting_page_apply-action"
              @click="onShowListPageApplied">
              View All
            </div>
            <div
              v-else
              v-popover:tooltip.right="'There is no page to display'"
              class="gf_setting_page_apply-action gf_setting_page_apply-action--disable">
              View All
            </div>
            <ListPageApplied
              v-if="isShowListPageApplied"
              :style-top-page-applied="styleTopPageApplied"
              :list-pages-applied="sortListPagesApplied"
              :label="currentPreset.name"
              @onHidePageApplied="onHidePageApplied"
              @clickAway="onHidePageApplied" />
          </div>
        </div>
        <GuideCustomizeStyle
          v-if="!obGlobalStyle.customizeStyle"
          guide="customizeStyle"
          title="Customize styles"
          link="https://help.gempages.net/articles/customize-global-style"
          content="Learn how to use Preset to customize your pages" />
      </div>
      <div class="gf_preset__action">
        <template v-if="isEditedCurrentPreset">
          <div class="gf_preset__action-col gf_preset__action-discard">
            <button class="gf_preset__action-btn button-14-medium" @click="discardCurrentPreset()">
              <span class="gf_preset__action-label">Discard</span>
            </button>
          </div>
          <div class="gf_preset__action-col gf_preset__action-publish">
            <PopupOnboarding
              v-if="!obGlobalStyle.savePreset && obGlobalStyle.firstSavePreset"
              type-o-b="firstSavePreset"
              :p-style="{
                position: 'absolute',
                bottom: '60px',
              }"
              :style-arrow="{
                position: 'absolute',
                transform: 'rotate(-90deg)',
                bottom: '-14px',
                left: '40px',
              }"
              :title="$t('sidebarGS.presetDetail.buttonUpdateTooltip.title')"
              :content="$t('sidebarGS.presetDetail.buttonUpdateTooltip.desc')" />

            <ProcessButton
              v-model:status="processStatus"
              class="gf_preset__action-btn button-14-medium"
              @click="confirmUpdatePreset">
              <template #loading>Updating</template>
              <template #success>Success</template>
              <template #error>Error</template>
              <template #default>Update</template>
            </ProcessButton>
          </div>
        </template>
        <template v-else>
          <div class="gf_preset__action-col gf_preset__action-apply">
            <PopupOnboarding
              v-if="obGlobalStyle.firstSavePreset && !obGlobalStyle.applyPreset"
              type-o-b="applyPreset"
              :p-style="{
                position: 'absolute',
                bottom: '50px',
              }"
              :style-arrow="{
                position: 'absolute',
                transform: 'rotate(-90deg)',
                bottom: '-14px',
                left: '40px',
              }"
              :title="$t('sidebarGS.presetDetail.buttonApplyTooltip.title')"
              :content="$t('sidebarGS.presetDetail.buttonApplyTooltip.desc')" />

            <button class="gf_preset__action-btn button-14-medium" :disabled="isAppliedPreset" @click="applyThisPage">
              <span class="gf_preset__action-label">{{
                isAppliedPreset ? 'Applied Preset' : 'Apply to current page'
              }}</span>
            </button>
          </div>
        </template>
      </div>
      <ApplyPresetModal
        v-if="isShowModalApplyPreset"
        @cancel="closeModal(typeModal.applyPreset)"
        @applyPageSelect="applyPageSelect" />
      <NotifyModal
        v-if="isShowModalNotify"
        :txt-header="txtHeader"
        :txt-description="txtDescription"
        :txt-warning="txtWarning"
        @action="actionNotify"></NotifyModal>
      <NotifyModal
        v-if="confirmUpdatePresetModal"
        :txt-header="(confirmUpdatePresetModalData as any).txtHeader"
        :txt-description="(confirmUpdatePresetModalData as any).txtDescription"
        :txt-button-confirm="(confirmUpdatePresetModalData as any).txtButtonConfirm"
        :txt-warning="(confirmUpdatePresetModalData as any).txtWarning"
        @action="actionUpdatePreset">
      </NotifyModal>
    </template>
    <template v-if="showEditPreset">
      <EditPreset
        :default-target-component="defaultTargetComponent"
        @backLiveThemePreset="backLiveThemePreset"
        @changeTargetComponent="changeTargetComponent" />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import QuickNavigation from './common/QuickNavigation.vue';
import ApplyPresetModal from './modal/ApplyPresetModal.vue';
import GuideCustomizeStyle from './guide/GuideCustomizeStyle.vue';
import NotifyModal from './modal/NotifyModal.vue';
import EditPreset from './Preset.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { mutations, actions } from '@modules/editor-sidebar';
import PopupStepOnboarding from './onboarding/PopupStepOnboarding.vue';
import PopupOnboarding from './onboarding/PopupOnboarding.vue';
import { cloneDeep } from '@/utils/common';
import { $gfLeftSideBar, $gryffBody, $jQuery } from '@/app/index';
import { actions as commonActions } from '@/store/common/types';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { app } from '@/store';
import ProcessButton from '@/core/components/ProcessButton.vue';
import FooterPresetOption from '../utils/mixins/FooterPresetOption';
import Preset from '../utils/mixins/Preset';
import { generateCssString } from '@modules/global-style';
import ListPageApplied from './modal/ListPageApplied.vue';
import Tooltip from '@/core/components/Popover/Tooltip.vue';

interface DataInterface {
  color1: string;
  namePreset: string;
  settingStyles: Array<{
    key: string;
    title: string;
    listPreset: Array<{
      name: string;
      icon: string;
      key: string;
    }>;
  }>;
  showOptions: boolean;
  showPresetModal: boolean;
  showEditPreset: boolean;
  defaultTargetComponent: string;
  confirmType: string;
  step: number;
  confirmUpdatePresetModal: boolean;
  confirmUpdatePresetModalData: object;
  isShowListPageApplied: boolean;
  styleTopPageApplied: number;
}

export default defineComponent({
  name: 'LiveThemePreset',
  components: {
    PopupStepOnboarding,
    PopupOnboarding,
    GuideCustomizeStyle,
    QuickNavigation,
    ApplyPresetModal,
    NotifyModal,
    EditPreset,
    ProcessButton,
    ListPageApplied,
    Tooltip,
  },
  mixins: [FooterPresetOption, Preset],
  props: {
    typeModal: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: (): DataInterface => ({
    color1: '#fff',
    namePreset: "Live Theme's Preset",
    step: 1,
    settingStyles: [
      {
        key: 'design-system',
        title: 'Design System',
        listPreset: [
          {
            name: 'Color',
            icon: 'icon icon-color',
            key: 'color',
          },
          {
            name: 'Text',
            icon: 'icon icon-text',
            key: 'text',
          },
          {
            name: 'Border',
            icon: 'icon icon-border-line',
            key: 'border',
          },
          {
            name: 'Corner',
            icon: 'icon icon-corner',
            key: 'corner',
          },
          {
            name: 'Spacing',
            icon: 'icon icon-spacing',
            key: 'spacing',
          },
        ],
      },
      {
        key: 'elements',
        title: 'Elements',
        listPreset: [
          {
            name: 'Button',
            icon: 'icon icon-button',
            key: 'button',
          },
        ],
      },
    ],
    showOptions: false,
    showPresetModal: false,
    showEditPreset: false,
    defaultTargetComponent: '',
    confirmType: '',
    confirmUpdatePresetModal: false,
    confirmUpdatePresetModalData: {},
    isShowListPageApplied: false,
    styleTopPageApplied: 0,
  }),
  computed: {
    ...mapState('sidebar', {
      modalNotify: 'presetModalNotify',
      isShowModalApplyPreset: 'presetModal',
      currentPreset: 'currentPreset',
      previewPreset: 'previewPreset',
      componentTargetGlobalStyle: 'componentTargetGlobalStyle',
      linkedPresetId: 'linkedPresetId',
      presets: 'presets',
    }),
    ...mapState('app', {
      pageInfo: 'pageInfo',
      shopMeta: 'shopMeta',
    }),
    ...mapGetters('account', {
      getCurrentPreset: 'getCurrentPreset',
    }),
    obGlobalStyle() {
      return this.shopMeta.onboardingGlobalStyle;
    },
    visiblePopupStepOnboarding() {
      return !this.obGlobalStyle.firstViewListPack && !this.previewPreset;
    },
    stateStepOB() {
      if (this.step === 2) {
        return 'text';
      }

      if (this.step === 3) {
        return 'button';
      }

      return 'color';
    },
    txtHeader() {
      switch (this.modalNotify) {
        case this.typeModal.applyPreset:
          return 'Apply preset to current page?';
        case this.typeModal.applyPresetCurrent:
          return 'Apply preset to current page?';
        case this.typeModal.applyPresetSelected:
          return 'Apply preset to selected pages?';
        case this.typeModal.publishPresetCurrent:
          return 'Publish Preset';
        case this.typeModal.publishPresetSelected:
          return 'Publish Preset';
      }
      return '';
    },
    txtDescription() {
      switch (this.modalNotify) {
        case this.typeModal.applyPreset:
          return 'All styles (typography, color, border, corner, spacing) in each elements of current page will be applied the preset. Your custom style will be replaced.';
        case this.typeModal.applyPresetCurrent:
          return 'All styles (typography, color, border, corner, spacing) in each elements of current page will be applied the preset. Your custom style will be replaced.';
        case this.typeModal.applyPresetSelected:
          return 'All styles (typography, color, border, corner, spacing) in each elements of current page will be applied the preset. Your custom style will be replaced.';
        case this.typeModal.publishPresetCurrent:
          return 'The changes will be applied into your live page automatically.';
        case this.typeModal.publishPresetSelected:
          if (this?.pageInfo?.page?.publishedWithGs) {
            return 'All changes will be automatically applied to your live page.';
          }
          return 'All changes will be applied to the draft page. Publish the page to apply saved changes to the live page.';
      }
      return '';
    },
    txtWarning() {
      switch (this.modalNotify) {
        case this.typeModal.applyPreset:
          return 'You need to publish the page to apply changes into live page.';
        case this.typeModal.applyPresetCurrent:
          return 'You need to publish the page to apply changes into live page.';
        case this.typeModal.applyPresetSelected:
          return 'You need to publish the page to apply changes into live page.';
        case this.typeModal.publishPresetCurrent:
          return 'This action can not be undone.';
        case this.typeModal.publishPresetSelected:
          return "<i class='icon icon-warn-triangle'></i>This action can not be undone.";
      }
      return '';
    },
    isShowModalNotify() {
      return this.modalNotify.length > 0 && this.modalNotify !== this.typeModal.applyPreset;
    },
    presetID() {
      return this.currentPreset?.id;
    },
    pageID() {
      // eslint-disable-next-line camelcase
      return this.pageInfo?.page?.g_id;
    },
    isEditedCurrentPreset() {
      return (this as any).$store.getters['sidebar/PRESET_IS_EDITED'];
    },
    isAppliedPreset() {
      return this.linkedPresetId == this.currentPreset.id;
    },
    lengthListPageApplied() {
      return this.currentPreset.linkedPages && this.currentPreset.linkedPages.length
        ? this.currentPreset.linkedPages.length
        : 0;
    },
    sortListPagesApplied() {
      let list = this.currentPreset.linkedPages;
      list = list.sort((a: any, b: any) => {
        return new Date(a.updated_at).getTime() <= new Date(b.updated_at).getTime() ? 1 : -1;
      });
      return list;
    },
  },
  watch: {
    componentTargetGlobalStyle(newVal) {
      if (newVal) {
        this.settingStyleAction(newVal);
      }
    },
    isEditedCurrentPreset(isChange) {
      if (isChange && !this.shopMeta.onboardingGlobalStyle.firstSavePreset) {
        const payload = cloneDeep(this.shopMeta);
        payload.onboardingGlobalStyle.firstSavePreset = true;
        (app as any).$store.state['app']['shopMeta']['onboardingGlobalStyle']['firstSavePreset'] = true;
        this.updateShopMeta(payload);
      }
    },
  },
  created() {
    this.trackEvent({ eventId: EDITOR_EVENT.GS_PRESET_DETAIL_VIEWD });
    (window as any).blockUpdateShopMeta = false;
  },
  methods: {
    ...mapMutations('sidebar', {
      commitPresetModalNotify: mutations.PRESET_MODAL_NOTIFY,
      commitPresetModal: mutations.PRESET_MODAL,
      setViewTargetPreset: mutations.SET_VIEW_TARGET_PRESET,
      setComponentTargetGlobalStyle: mutations.SET_COMPONENT_TARGET_GLOBAL_STYLE,
      setPreviewPreset: mutations.SET_PREVIEW_PRESET,
      setPresetToPresetList: mutations.SET_PERSET_TO_PRESET_LIST,
      setCurrentPreset: mutations.SET_CURRENT_PRESET,
      setIsPublishPreset: mutations.SET_IS_PUBLISH_PRESET,
      setCurrentPresetInPage: mutations.SET_CURRENT_PRESET_IN_PAGE,
    }),
    ...mapActions('sidebar', {
      publicPreset: actions.PUBLIC_PRESET,
      applyPreset: actions.APPLY_PRESET,
      savePresetOptions: actions.SAVE_PRESET_OPTIONS,
    }),
    ...mapMutations('iframe', {
      alert: 'alert',
    }),
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    ...mapActions('common', {
      trackEvent: commonActions.TRACK_EVENT,
    }),
    isFirstViewListPack(item: any) {
      return (
        this.stateStepOB === item.key &&
        !this.obGlobalStyle.firstViewListPack &&
        this.obGlobalStyle.previewPreset &&
        !this.previewPreset
      );
    },
    closePopupOB() {
      const payload = cloneDeep(this.shopMeta);
      payload.onboardingGlobalStyle.publicPreset = true;
      this.updateShopMeta(payload);
    },
    nextStepOB() {
      this.step++;
    },
    async applyThisPage() {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_APPLY_PRESET_CLICKED });
      const preset = this.presets.find((item: any) => +item.id === +this.presetID);
      if (!preset) return;
      if (await this.applyPresetThisPage(this.pageID, preset)) {
        this.$emit('previewPreset', preset, true);
      }
    },
    applyOtherPage() {
      this.openModal(this.typeModal.applyPreset);
    },
    async onPublicPreset() {
      const presetName = this?.currentPreset?.name || 'current preset';
      this.alert({
        show: true,
        title: '',
        message: `<span class="typo-semibold">Publishing</span> ${presetName}.`,
        typeAlert: 'info',
        delay: 'infinity',
      });
      try {
        const res = await this.publicPreset({ presetId: this.presetID });
        if (res.status === 'success') {
          const payload = cloneDeep(this.shopMeta);
          payload.onboardingGlobalStyle.firstPublicPreset = true;
          this.updateShopMeta(payload);

          const publishedCurrentPreset = { ...this.currentPreset, isEdited: false };
          this.setCurrentPreset(publishedCurrentPreset);
          this.setPresetToPresetList(publishedCurrentPreset);

          this.alert({
            show: true,
            title: '',
            message: `Successfully <span class="typo-semibold">publish</span> ${presetName}.`,
            typeAlert: 'success',
          });
          this.setIsPublishPreset(true);
        } else {
          this.alert({
            show: true,
            title: '',
            message: `Failed to <span class="typo-semibold">publish</span> ${presetName} as server is not responding.`,
            typeAlert: 'error',
          });
        }
      } catch (error) {
        this.alert({
          show: true,
          title: '',
          message: `Failed to <span class="typo-semibold">publish</span> ${presetName} as server is not responding.`,
          typeAlert: 'error',
        });
      }
    },
    onBack() {
      this.$emit('back', this.isEditedCurrentPreset);
    },
    backLiveThemePreset() {
      this.showEditPreset = false;
    },
    settingStyleAction(type: string) {
      this.showEditPreset = true;
      this.defaultTargetComponent = type;
      this.setViewTargetPreset('');
      this.setComponentTargetGlobalStyle('');
    },
    changeTargetComponent(type: string) {
      if (type) {
        this.defaultTargetComponent = type;
      }
    },
    hideOptions() {
      this.showOptions = false;
    },
    closeModal(type: string) {
      if (type == this.typeModal.applyPreset) {
        this.commitPresetModal(false);
      }
      this.commitPresetModalNotify('');
      return false;
    },
    openModal(type: any) {
      if (type == this.typeModal.publishPresetSelected) {
        // this.trackEvent({eventId: EDITOR_EVENT.GS_PUBLISH_PRESET_CLICKED});
      }
      this.confirmType = type;
      if (type === this.typeModal.applyPreset) {
        this.commitPresetModal(true);
      }
      this.commitPresetModalNotify(type);
      return false;
    },
    applyPageSelect() {
      this.commitPresetModalNotify(this.typeModal.applyPresetSelected);
    },
    actionNotify(type: string): void {
      if (type === 'cancel') {
        this.commitPresetModalNotify('');
        return;
      }

      this.commitPresetModalNotify('');
      if (this.confirmType === this.typeModal.applyPresetCurrent) {
        return (this as any).applyThisPage();
      }

      if (this.confirmType === this.typeModal.publishPresetSelected) {
        return (this as any).onPublicPreset();
      }
      return;
    },
    discardCurrentPreset() {
      this.trackEvent({ eventId: EDITOR_EVENT.GS_DISCARD_BUTTON_CLICKED });
      const preset = this.presets.find((item: any) => item.id == this.currentPreset.id);
      if (preset) {
        this.setCurrentPreset(preset);
      }

      const $gfFrameContents = $jQuery('#gfFrame').contents();
      $gfFrameContents.find('.gryffeditor .gf_gs-global-style-preview').remove();

      if (this.previewPreset) {
        const cssString = generateCssString(this.currentPreset);
        $gfFrameContents
          .find('.gryffeditor')
          .append(`<style class="gf_gs-global-style-preview" type="text/css">${cssString}</style>`);
      }
      this.ALERT({
        show: true,
        title: '',
        message: `Successfully <span class="typo-semibold">discarded</span> all the changes in <b>${preset?.name}</b>`,
        typeAlert: 'success',
      });
    },
    confirmUpdatePreset() {
      if (!this.currentPreset.linkedPages || !this.currentPreset.linkedPages.length) {
        this.updateCurrentPreset();
        return;
      }

      let txtHeader = this.$t('modals.updatePresetGS.pageIsNotPublished.title');
      let txtDescription = this.$t('modals.updatePresetGS.pageIsNotPublished.desc');
      let txtWarning = '';
      if (this?.pageInfo?.page?.publishedWithGs) {
        txtHeader = this.$t('modals.updatePresetGS.pageIsPublished.title');
        txtDescription = this.$t('modals.updatePresetGS.pageIsPublished.desc');
        txtWarning = this.$t('modals.updatePresetGS.pageIsPublished.warning');
      }
      this.confirmUpdatePresetModalData = {
        txtHeader,
        txtDescription,
        txtButtonConfirm: 'Update',
        txtWarning,
      };
      this.confirmUpdatePresetModal = true;
    },
    actionUpdatePreset(type: string) {
      this.confirmUpdatePresetModal = false;
      if (['cancel', 'close'].includes(type)) {
        return;
      }
      this.updateCurrentPreset();
    },
    onShowListPageApplied() {
      const length = this.currentPreset.linkedPages.length;
      const positionActionByTop = (this as any).$refs.pageApplyAction.getBoundingClientRect().bottom;
      const windowHeight = window.innerHeight;
      const positionActionByBottomWindow = windowHeight - positionActionByTop;
      const countHeight = 40 + 4 + 44 * length - 4; // Height header = 48, Padding Body = 4, Height Item In Body = 52, Margin Bottom = 4
      const heightBox = countHeight > 480 ? 480 : countHeight;
      this.styleTopPageApplied =
        heightBox > positionActionByBottomWindow ? positionActionByBottomWindow - heightBox : 0;
      this.isShowListPageApplied = true;
      const _this = this;
      $gfLeftSideBar().data('gfleftsidebar').onBackgroundIframe('backgroundAdv');
      setTimeout(function () {
        $gryffBody()
          .find('.backgroundAdv')
          .off('mousedown.removeBackground')
          .on('mousedown.removeBackground', function () {
            _this.onHidePageApplied();
          });
      }, 0);
      return false;
    },
    onHidePageApplied() {
      this.isShowListPageApplied = false;
      $gfLeftSideBar().data('gfleftsidebar').offBackgroundIframe('backgroundAdv');
      return false;
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';

.gf_live-theme-preset {
  position: relative;
  height: 100%;

  .gf_setting {
    padding-bottom: 56px;
    height: calc(100vh - 172px);
    display: flex;
    flex-direction: column;

    &__scroll-body {
      overflow: unset !important;
      overflow-x: visible !important;
      overflow-y: hidden !important;
      height: calc(100vh - 172px);
    }

    .setting {
      flex: 1;
    }

    &__preset {
      &-title {
        padding: 16px 12px 12px 12px;
        color: map-get($text-dark-mode, 'low-contrast');
      }

      .gf_setting__list-item {
        .gf_setting__item {
          padding: 12px 8px;
          background: map-get($hybrid-shade-dark, '300');
          border-radius: 3px;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          margin-left: 12px;
          margin-right: 12px;
          cursor: pointer;
          color: white;

          &:hover {
            background: map-get($hybrid-shade-dark, '200');
          }

          &--icon {
            margin-right: 8px;
            min-width: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          &--label {
            flex: auto;
            color: map-get($hybrid-shade-light, '100');
          }

          &--button {
            width: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: -8px 0;
            height: 32px;

            &:hover {
              background: map-get($hybrid-shade-dark, '300');
              border-radius: 3px;
            }
          }
        }
      }
    }
    &_page_apply {
      margin-top: 4px;
      padding: 12px;
      display: flex;
      position: relative;
      &.show-list::before {
        content: '';
        right: -12.5px;
        top: 50%;
        position: absolute;
        width: 0;
        height: 0;
        transform: translate(-50%, -50%);
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 8px solid map-get($hybrid-shade-dark, '400');
      }
      &-count {
        flex: 1;
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        line-height: 14px;
        color: map-get($text-dark-mode, 'low-contrast');
      }
      &-action {
        cursor: pointer;
        width: fit-content;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: map-get($primary-blue-ui-kit, '200');
        &:hover {
          color: map-get($primary-blue-ui-kit, '250');
        }
        &--disable {
          padding-right: 12px;
          margin-right: -12px;
          cursor: context-menu;
          color: map-get($primary-blue-ui-kit, '375');
          &:hover {
            color: map-get($primary-blue-ui-kit, '375');
          }
        }
      }
    }
  }

  .gf_preset__action {
    z-index: 99;
    display: flex;
    flex-wrap: nowrap;
    position: relative;
    bottom: 56px;
    left: 0;
    padding: 8px 12px 8px 12px;
    max-width: 100%;
    width: 100%;
    background: map-get($hybrid-shade-dark, '400');
    @media screen and (max-width: 1299px) {
      padding: 8px;
    }

    &-discard {
      padding-right: 4px;
      position: relative;
      flex: auto;
      height: 40px;

      .gf_preset__action-btn {
        background-color: map-get($hybrid-shade-dark, '300');

        &:hover {
          background-color: map-get($hybrid-shade-dark, '200');
        }
      }
    }

    &-publish {
      padding-left: 4px;
      width: auto;
      min-width: 120px;
      height: 40px;

      .gf_preset__action-btn {
        width: max-content;
        min-width: 120px;
        background-color: map-get($primary-blue-ui-kit, '300');

        &:hover {
          background-color: map-get($primary-blue-ui-kit, '325');
        }
      }
    }

    &-apply {
      position: relative;
      flex: auto;
      height: 40px;

      .gf_preset__action-btn {
        background-color: map-get($primary-blue-ui-kit, '300');

        &:hover {
          background-color: map-get($primary-blue-ui-kit, '325');
        }
      }
    }

    &-btn {
      padding: 12px;
      width: 100%;
      height: 100%;
      color: map-get($hybrid-shade-light, '100');
      display: flex;
      align-items: center;
      border-radius: 3px;
      border: 0;
      @media screen and (max-width: 1299px) {
        padding: 12px 4px;
      }

      &:disabled {
        background-color: map-get($hybrid-shade-dark, '300') !important;
        color: map-get($text-light-mode, 'disabled') !important;
      }

      .gf_preset__action-label {
        flex: auto;
      }

      .gf_preset__action-icon {
        width: 20px;
        height: 20px;
        margin-left: 8px;
        transform: unset;
        transition: transform 300ms;
      }

      &.gf_preset__action-show {
        .gf_preset__action-icon {
          transform: scaleY(-1);
          transition: transform 300ms;
        }
      }
    }

    &__options {
      position: absolute;
      left: 0;
      // top: -88px;
      top: -55px;
      padding: 8px;
      background-color: map-get($hybrid-shade-dark, '300');
      border-radius: 3px;
      box-shadow: 0 12px 38px rgba(34, 34, 34, 0.0393604), 0 5.01331px 15.8755px rgba(34, 34, 34, 0.056545),
        0 2.68036px 8.4878px rgba(34, 34, 34, 0.07), 0 1.50259px 4.75819px rgba(34, 34, 34, 0.083455),
        0 0.798012px 2.52704px rgba(34, 34, 34, 0.10064), 0 0.332071px 1.05156px rgba(34, 34, 34, 0.14);

      &-item {
        &--action {
          width: max-content;
          min-width: 136px;
          padding: 8px 8px 10px 8px;
          margin-bottom: 4px;
          border: 0;
          background: map-get($hybrid-shade-dark, '300');
          color: map-get($hybrid-shade-light, '100');
          text-align: left;

          &:hover {
            background: map-get($hybrid-shade-dark, '200');
            border-radius: 3px;
          }
        }

        &:last-child {
          .gf_preset__action__options-item--action {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .gf_preset__edited-warning {
    position: absolute;
    top: 0;
    transform: translateY(-100%);
    background: #252525;
    display: flex;
    align-items: center;
    color: #fff1d0;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    padding: 5px 0;

    &--icon {
      padding: 9px;
    }

    &--icon-img {
      width: 26.5px;
    }
  }
}
</style>
